export const styles = {
	
	mainBtn : {
		width    : '25%',
		minWidth : '300px',
	},
};
